/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Mode_ContactInputs */

const en_messages_mode_contact = /** @type {(inputs: Messages_Mode_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const he_messages_mode_contact = /** @type {(inputs: Messages_Mode_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`איש קשר`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Messages_Mode_ContactInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_mode_contact = /** @type {((inputs?: Messages_Mode_ContactInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Mode_ContactInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_mode_contact(inputs)
	return he_messages_mode_contact(inputs)
});